import { render, staticRenderFns } from "./url_list.vue?vue&type=template&id=2de9e8bd&scoped=true&lang=pug&"
import script from "./url_list.vue?vue&type=script&lang=js&"
export * from "./url_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de9e8bd",
  null
  
)

export default component.exports